"use client";
import * as React from "react";
const SvgSavingsFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14.264 4.842 12.448 3.05a4.17 4.17 0 0 1 .256-.908c.064-.142.096-.292.096-.458A1.19 1.19 0 0 0 11.6.5a4.014 4.014 0 0 0-3.2 1.579h-4C1.968 2.079 0 4.021 0 6.42c0 2.4 2 9.079 2 9.079h4.4V13.92H8v1.58h4.4l1.344-4.413L16 10.345V4.842h-1.736ZM8.8 6.026h-4V4.447h4v1.58Zm2.4 1.58c-.44 0-.8-.356-.8-.79 0-.434.36-.79.8-.79.44 0 .8.356.8.79 0 .434-.36.79-.8.79Z" }));
export {
  SvgSavingsFilled as default
};
